import axios from 'axios'
// 创建axios实例
const service = axios.create({
  //baseURL: process.env.VUE_APP_CMS_URL, // api 的 base_url
  timeout: 15000, // 请求超时时间
  headers:{
    "Content-Type":"application/json; charset=utf-8",
    "Accept-Language":"zh-CN",
    'Cache-Control': 'no-cache'
  }
})
// request拦截器
service.interceptors.request.use(
    config => {
      return config
    },
    error => {
      Promise.reject(error)
    }
  )
  
  // response 拦截器
  service.interceptors.response.use(
    response => {
      if (response.status !== 200) {
          return Promise.reject(response.data);
      } else {
          return response;
      }
    },
    err => {
      var response = err.response;
      return Promise.reject(response);
    }
  )
export function get(url){
    return new Promise((resolve, reject)=>{
        // if(!(/^http|https/.test(url))){
        //     url = process.env.VUE_APP_CMS_URL + url;
        // }
        service.get(url).then(response=>{
            var data = response.data;
            if(typeof data == 'object'){
                resolve(data);
            }else{
                reject(data);
            }
        }).catch(err=>{
          reject(err);
        })
    })
}
